<template>
  <span
    :class="selected ? 'is-checked' : ''"
    class="select-indicator tw-flex tw-items-center tw-justify-center tw-bg-white tw-border-solid tw-border tw-rounded-full tw-border-grey-800"
  >
    <span v-if="selected" class="select" />
  </span>
</template>

<script>
export default {
  props: {
    selected: Boolean
  }
};
</script>

<style scoped>
.select-indicator {
  width: 24px;
  height: 24px;
}

.select-indicator .tw-icon {
  font-size: 28px;
}

.select {
  background: black;
  display: block;
  width: 18px;
  height: 18px;
  border-radius: 50%;
}
</style>
